import { PrincipalEditForm } from './EditPrincipal';
import { hasUserPermission } from '../utils/userPermissions';
import { faHandshake } from '@fortawesome/free-solid-svg-icons';
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from "react";
import { Alert, Button } from '@themesberg/react-bootstrap';
import { PagePrincipalTable } from "../components/Tables";
import { PrincipalForm } from "./CreatePrincipal";
import { Link } from 'react-router-dom';

export default () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [creationMessage, setCreationMessage] = useState("");

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handlePrincipalCreated = (result) => {
    setShowCreateModal(false);
    setCreationMessage(result.message || 'Principal created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission('principals', 'edit')) return;
    setCreationMessage('');
    setEditingId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingId(null);
  };

  const handleUpdated = result => {
    setEditingId(null);
    setCreationMessage(result.message || 'Principal updated successfully.');
    setRefreshKey(value => value + 1);
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">Principal</h2>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <PermissionGate module="principals" action="add"><Button
            variant="primary"
            className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none"
            onClick={() => { setCreationMessage(""); setShowCreateModal(true); }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            Create Principal
          </Button></PermissionGate>
          <Link to="/product">
            <Button variant="primary" className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
              Product Categories
            </Button>
          </Link>
          {isLoggedInSuperOrAdmin && (
            <Link to="/pdeleted">
              <Button variant="outline-secondary" className="ms-2 py-2 px-3">
                Deleted Records
              </Button>
            </Link>
          )}
        </div>
      </div>

      {creationMessage && (
        <Alert variant="success" dismissible onClose={() => setCreationMessage("")}>
          {creationMessage}
        </Alert>
      )}

      <div className="my-auto">
        <PagePrincipalTable refreshKey={refreshKey} onEditPrincipal={openEditModal} />
      </div>

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-principal-title"
        title="Create Principal"
        description="Add a principal to organize your product categories."
        icon={faHandshake}
      >
        {showCreateModal && (
          <PrincipalForm
            onSuccess={handlePrincipalCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-principal-title"
        title="Edit Principal"
        description="Update principal details."
        icon={faHandshake}
      >
        {editingId !== null && (
          <PrincipalEditForm key={editingId} principalId={editingId}
            onSuccess={handleUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </>
  );
};
